const url = '/service-prices';
const Provider = 'ServicePrices';
const dbModel = 'ServicePrices';

export { url, Provider, dbModel };
